import { useContext } from "react";
import TableFetchContext from "components/common/PaginatedEntityTable/TableFetchContext";
const useRefetchTable = () => {
  var _a;
  const tableFetchContext = useContext(TableFetchContext);
  return (_a = tableFetchContext == null ? void 0 : tableFetchContext.refetch) != null ? _a : () => {
  };
};
export default useRefetchTable;
